import { render, staticRenderFns } from "./CartMenu.vue?vue&type=template&id=49208770&"
import script from "./CartMenu.vue?vue&type=script&lang=js&"
export * from "./CartMenu.vue?vue&type=script&lang=js&"
import style0 from "./CartMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports